export default __webpack_public_path__ + "static/media/RiskBackground.3d80801e.png";